import { useQuery } from "@apollo/client";
import { useState } from "react";
import { GET_PERSON_AUTOCOMPLETE_QUERY } from "../../api/person/queries";
import PersonIcon from "../icons/PersonIcon";
import AutoComplete, { AutoCompleteOnSelectedItemChange } from "./AutoComplete";
import { AutoCompleteItem, PersonAutoCompleteResponse } from "./interface";
import { startCase } from "lodash";

interface IAutoCompletePersonProps {
  onSelectedItemChange: AutoCompleteOnSelectedItemChange;
  className?: string;
  isInvalidClass?: string;
  sizeLarge?: boolean;
  sizeSmall?: boolean;
  clearAfterSelection?: boolean;
  erUdoevendeAdvokat?: boolean;
  erFmuretssagsproeveCensor?: boolean;
  includeFirstItem?: boolean;
  placeholder?: string;
  onInputBlur?: React.FocusEventHandler<HTMLInputElement> | undefined;
  focusInputOnMount?: boolean;
}
export default function AutoCompletePerson({
  onSelectedItemChange,
  className,
  isInvalidClass,
  sizeLarge,
  sizeSmall,
  clearAfterSelection,
  erUdoevendeAdvokat,
  erFmuretssagsproeveCensor,
  includeFirstItem,
  placeholder,
  onInputBlur,
  focusInputOnMount,
}: IAutoCompletePersonProps) {
  const [inputValue, setInputValue] = useState("");

  const { data, loading } = useQuery<{
    personer: {
      edges: {
        node: PersonAutoCompleteResponse;
      }[];
    };
  }>(
    GET_PERSON_AUTOCOMPLETE_QUERY({
      q: inputValue,
      erUdoevendeAdvokat,
      erFmuretssagsproeveCensor,
    }),
    {
      variables: { q: inputValue },
      skip: !inputValue,
    },
  );

  const items =
    !loading && data && data.personer.edges.length > 0
      ? data.personer.edges.map((e) => {
          const p = e.node;

          let firma;
          if (p.primaerPersonFirmaRelation !== null) {
            firma = p.primaerPersonFirmaRelation;
          } else {
            firma = p.personFirma.find(
              (f) => f.periode.tilDatoInklusiv === "9999-12-31",
            );
          }

          const item: AutoCompleteItem = {
            id: p.id,
            header: `${p.fuldtNavn}`,
            subheader: `${p.kundeNr}${
              " | " + (p.erUdoevende ? "Udøvende" : "Ikke udøvende")
            }${" | " + startCase(p.personart.toLocaleLowerCase())}${
              firma ? " | " + firma.firma.navn1 : ""
            }`,
            icon: <PersonIcon height={26} />,
          };
          return item;
        })
      : [];

  return (
    <AutoComplete
      className={className}
      isInvalidClass={isInvalidClass}
      sizeLarge={sizeLarge}
      sizeSmall={sizeSmall}
      clearAfterSelection={clearAfterSelection}
      includeFirstItem={includeFirstItem}
      items={items}
      itemToString={(item) => {
        if (item?.id !== "first") {
          return (item?.header as string) ?? "";
        } else {
          return inputValue;
        }
      }}
      loading={loading}
      onSelectedItemChange={onSelectedItemChange}
      placeholder={placeholder ? placeholder : "Søg på person ..."}
      setInputValue={setInputValue}
      onInputBlur={onInputBlur}
      focusInputOnMount={focusInputOnMount}
    />
  );
}
